













































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { QuoteApi } from '@/api/quote-api';
import { Quote } from '@/models/quote';
import { Order } from '@/models/order';
import { OrderItem } from '@/models/order-item';
import { dateParse } from '@/date-picker-parser';
import { OrderApi } from '@/api/order-api';
import { DateTime } from 'luxon';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

const orderApi = new OrderApi();

@Component({
    components: {
        ValidationProvider,
        ValidationObserver,
    },
})
export default class OrderForm extends Vue {
    @Prop({ required: true }) public quote: Quote;
    private keyIndex: number = 0;

    public items: Array<OrderItem> = new Array<OrderItem>(...[
        { key: this.keyIndex++, id: null, orderId: null, purchaseOrderNumber: null, salesOrderNumber: null, supplier: null, buyer: null, dueDate: null, createdById: null, createdBy: null, createdDate: null }
    ]);

    public get isValid(): boolean {
        return this.items.length > 0;
    }

    public parseDate = dateParse;

    public addItem(): void {
        this.items.push({ key: this.keyIndex++, id: null, orderId: null, purchaseOrderNumber: null, salesOrderNumber: null, supplier: null, buyer: null, dueDate: null, createdById: null, createdBy: null, createdDate: null });
    }
    public removeItem(index: number): void {
        this.items.splice(index, 1);
    }
    public async Save(): Promise<void> {
        const order: Order = {
            quoteId: this.quote.id!,
            status: 0,
            items: this.items.map((item) => {
                const result: OrderItem = {
                    id: item.id,
                    orderId: item.orderId,
                    purchaseOrderNumber: item.purchaseOrderNumber,
                    salesOrderNumber: item.salesOrderNumber,
                    supplier: item.supplier,
                    buyer: item.buyer,
                    dueDate: item.dueDate,
                    createdById: item.createdById,
                    createdBy: item.createdBy,
                    createdDate: item.createdDate,
                };

                if (item.dueDate) {
                    result.dueDate = DateTime.fromFormat(item.dueDate, 'dd/MM/yyyy').toISODate();
                }

                return result;
            }),
        };

        const id = await orderApi.createAsync(order);

        this.$emit('order-saved', id);
    }
}
